import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthLayoutComponent } from '@features/auth/shared/components/auth-layout/auth-layout.component';
import { Router } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { navigateWithQueryParams } from '@features/auth/shared/redirect/redirect-helper';
import { GOBACK_LOGGIN_PAGE_URL } from '@features/auth/const';

@Component({
  standalone: true,
  imports: [CommonModule, AuthLayoutComponent, TranslocoModule],
  selector: 'app-error-view',
  templateUrl: './error-view.component.html',
  styleUrls: ['./error-view.component.css'],
})
export class ErrorViewComponent implements OnInit {
  private readonly router = inject(Router);
  constructor() { }

  ngOnInit() { }

  navigateToLogin() {
    // this.router.navigate([GOBACK_LOGGIN_PAGE_URL]);
    navigateWithQueryParams(this.router, [GOBACK_LOGGIN_PAGE_URL]);
  }
}
